import React, { Fragment, Component } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Header2 from "../components/header2";
import Footer from "../components/Footer";
import PageTitle from "../components/PageTitle";
import { Row, Col, Alert, Button, Modal, Card, Container } from "react-bootstrap";
import { FaCar, FaCog, FaPowerOff, FaCartPlus, FaUsers, FaUser, FaAngleRight, FaHome, FaBarcode } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getToken, https, getUser } from "../components/AuthUser";
import Form from "react-bootstrap/Form";
import "../css/CarDetail.css";
import { FaRupeeSign } from "react-icons/fa";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { createProxyMiddleware } from 'http-proxy-middleware';
import config from "../config";
import SettingIcon from "../img/setting-cog.svg";
import OilTypelIcon from "../img/hybrid-car.svg";
import RoadIcon from "../img/road.svg";

//const MySwal = withReactContent(Swal);
//MySwal.fire(result.data.message);
import axios from 'axios';
import { SHA256 } from "crypto-js";

function NavigateWrapper() {
  const navigate = useNavigate();

  return <CarBooking navigate={navigate} />;
}


class CarBooking extends Component {

  constructor(props) {
    super()

    // this.checkLogin=checkLogin();
    this.token = getToken();
    this.https = https();
    this.userData = getUser();
    this.state = {
      isLoading: false,
      showTooltip: false,
      suubmitvalue: '',
      attrs: false,
      submitbuttom: '',
      submitbuttom1: '',
      totalHours: '',
      totalRent: 0,
      newRent: 0,
      dis: 0,
      dis2: 0,
      name: '',
      mobile_number: '',
      email: '',
      address: '',
      to_address: localStorage.getItem('to_address'),
      from_address: localStorage.getItem('from'),
      toTime: '',
      fromTime: '',
      luggage: '',
      person: '',
      comment: localStorage.getItem('comment'),
      hours: '',
      days: '',
      gst: 0,
      insurance_amount: 0,
      insurance1: '0.00',
      insurance: '',
      ins: 0,
      show: false,
      submitbuttom: 'text',
      suubmitvalue: 'Submit',
      attrs: 'true',
      paymentUrl: "",
      coupon: '',
      coupon_dis: { display: "none" },
      readOnly: false,

    };
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleChangep = this.handleChangep.bind(this)
    this.handleChanges = this.handleChanges.bind(this)
    this.handleCoupon = this.handleCoupon.bind(this)
    this.handleCoupons = this.handleCoupons.bind(this)

    this.imagestore = this.imagestore.bind(this);
    this.imagestore1 = this.imagestore1.bind(this);
    this.imagestore2 = this.imagestore2.bind(this);

    this.id = localStorage.getItem('rent_id')
    this.state = {
      carArray: [],
      carArray1: [],
      carArray2: []
    };


  }




  handleChangep() {

    if (this.token) { } else {

      const MySwal = withReactContent(Swal);
      MySwal.fire('Please login/signup to book a car.');
      localStorage.setItem('booking_applay', 1);
      const { navigate } = this.props;
      navigate("../login");
      return true;

    }
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });



  }

  handleCoupons(event) {

    this.https.post('/login_verify', { token: this.token }).then((result) => {
      if (result.data.status === 0) {
        const { navigate } = this.props;
        navigate("../login");
      }
    })
    let totalRent = this.state.totalRent;
    let newRentp = 0;
    let newRent = totalRent - newRentp;

    const total1 = this.state.ins_amt + this.state.gst1 + newRent;
    const total = total1.toFixed(2);

    const newRentp1 = newRentp.toFixed(2);
    const newRent1 = newRent.toFixed(2);

    this.setState({
      dis1: newRentp,
      dis: newRentp1,
      dis2: 0,
      newRent1: newRent,
      tts: newRent,
      newRent: newRent1,
      coupon_dis: { display: "none" },
      total: total,
      total1: total1,
      coupon: '',
      readOnly: false,
    });

    const MySwal = withReactContent(Swal);
    MySwal.fire('Coupon removed');
  }


  handleCoupon(event) {

    this.https.post('/login_verify', { token: this.token }).then((result) => {
      if (result.data.status === 0) {
        const { navigate } = this.props;
        navigate("../logout");
      }
    })

    if (this.state.coupon === '' || this.state.coupon === undefined) {
      const MySwal = withReactContent(Swal);
      MySwal.fire('You first Enter Coupon Code');
    }

    this.https.post('/apply_coupon_code', { token: this.token, coupon: this.state.coupon }).then((result) => {
      let status = result.data.status;
      let message = result.data.message;
      if (status === 1) {


        let totalRent = this.state.totalRent;
        let newRentp = totalRent / 100 * result.data.data.dis;
        let newRent = totalRent - newRentp;

        const total1 = this.state.ins_amt + this.state.gst1 + newRent;
        const total = total1.toFixed(2);

        const newRentp1 = newRentp.toFixed(2);
        const newRent1 = newRent.toFixed(2);

        this.setState({
          dis1: newRentp,
          dis: newRentp1,
          dis2: result.data.data.dis,
          newRent1: newRent,
          tts: newRent,
          newRent: newRent1,
          coupon_dis: { display: "block" },
          total: total,
          total1: total1,
          readOnly: !this.state.readOnly,
        });



        const MySwal = withReactContent(Swal);
        MySwal.fire(result.data.data.dis + ' % Coupon discount applied');

      } else {

        let totalRent = this.state.totalRent;
        let newRentp = 0;
        let newRent = totalRent - newRentp;

        const total1 = this.state.ins_amt + this.state.gst1 + newRent;
        const total = total1.toFixed(2);

        const newRentp1 = newRentp.toFixed(2);
        const newRent1 = newRent.toFixed(2);

        this.setState({
          dis1: newRentp,
          dis: newRentp1,
          dis2: 0,
          newRent1: newRent,
          tts: newRent,
          newRent: newRent1,
          coupon_dis: { display: "none" },
          total: total,
          total1: total1,
          coupon: '',
          readOnly: false,
        });

        const MySwal = withReactContent(Swal);
        MySwal.fire(message);

      }



    })


  }

  handleChanges(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });




    if (value === true) {



      const xyz = this.state.hours === 0 ? this.state.days : this.state.days + 1;
      const insurance_amount1 = this.state.insurance_amount * xyz;
      const insurance_amount = insurance_amount1.toFixed(2);
      let tts1 = this.state.tts;
      let tts = tts1 + insurance_amount1;
      const gst1 = this.state.gst1;
      const gst = gst1.toFixed(2);

      const total1 = gst1 + tts;
      const total = total1.toFixed(2);

      this.setState({
        insurance1: insurance_amount,
        ins_amt: insurance_amount1,
        total: total,
        total1: total1
      });

    } else {

      const insurance_amount1 = 0;
      const insurance_amount = insurance_amount1.toFixed(2);
      let tts1 = this.state.tts;
      let tts = tts1 + insurance_amount1;
      const gst1 = tts1 / 100 * 2;
      const gst = gst1.toFixed(2);

      const total1 = this.state.gst1 + tts;
      const total = total1.toFixed(2);

      this.setState({
        insurance1: insurance_amount,
        ins_amt: insurance_amount1,
        total: total,
        total1: total1
      });
    }



  }


  handleMouseEnter = () => {
    this.setState({ showTooltip: true });
  }

  handleMouseLeave = () => {
    this.setState({ showTooltip: false });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.imagestore();
    this.imagestore1();
    this.imagestore2();

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      console.log('Razorpay SDK loaded successfully');
    };
    document.body.appendChild(script);
  }

  imagestore() {


    if (this.token) {


      this.setState({
        name: this.userData.name,
        mobile_number: this.userData.mobile_number,
        email: this.userData.email,
        address: this.userData.address
      });
    }

    let date1;

    if (localStorage.getItem("date") === null) {
      const now = new Date();

      const pad = (n) => n.toString().padStart(2, '0');

      const formatTime = (date) => {
        let hours = date.getHours();
        const minutes = pad(date.getMinutes());
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // hour '0' should be '12'
        return `${hours}:00 ${ampm}`;
      };

      const formatDate = (date) => {
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
      };

      // Round to the next hour and set minutes to 00
      let startDate = new Date(now);
      if (startDate.getMinutes() > 0) {
        startDate.setHours(startDate.getHours() + 1);
      }
      startDate.setMinutes(0, 0, 0); // Set minutes, seconds, milliseconds to 0

      // Add 12 hours for the end time
      let endDate = new Date(startDate.getTime() + 12 * 60 * 60 * 1000);

      date1 = `${formatDate(startDate)}, ${formatTime(startDate)} - ${formatDate(endDate)}, ${formatTime(endDate)}`;

    } else {
      date1 = localStorage.getItem("date");
    }
    const myArray = date1.split(' - ');


    const formattedDate = myArray[0].toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    const formattedDate2 = myArray[1].toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });




    this.https.post('/car_list_by_id', { token: this.token, id: this.id, date: date1.toUpperCase(), datetime: date1 }).then((result) => {
      let status = result.data.status;
      if (status === 1) {

        this.setState({
          fromTime: result.data.data[0].fromTime,
          toTime: result.data.data[0].toTimes
        });

        const tts = result.data.data[0].date1 * result.data.data[0].price;

        const price = result.data.data[0].price;
        const insurance_amount = result.data.data[0].insurance_amount;
        const days = result.data.data[0].days;

        const insurance_amounts = insurance_amount;

        //const price1 =price.toFixed(2);
        const tts1 = tts.toFixed(2);


        let gst1 = tts / 100 * 2;
        if (gst1 < 99) {
          gst1 = 99;
        }
        const gst = gst1.toFixed(2);

        const total1 = gst1 + tts;
        const total = total1.toFixed(2);


        this.setState({
          carArray: result.data.data,
          totalHours: result.data.data[0].date1,
          hours: result.data.data[0].hours,
          days: result.data.data[0].days,
          totalRent: tts1,
          newRent: tts1,
          dis: 0,
          dis2: 0,
          rate: price,
          insurance_amount: insurance_amounts,
          insurance1: '0.00',
          ins_amt: 0,
          tts: tts,
          gst: gst,
          gst1: gst1,
          total: total,
          total1: total1,
          coupon_dis: { display: "none" },
          readOnly: false,
        });


        result.data.data.map((val, key) => {

          let booking_status = val.booking_status;


          if (booking_status === 1) {

            this.setState({
              submitbuttom: 'text',
              suubmitvalue: 'Booked',
              attrs: 'true'
            });

          } else {

            this.setState({
              submitbuttom: 'text',
              suubmitvalue: 'Book Car',
              submitbuttom1: 'submit',
              attrs: 'true'
            });
          }


          if (this.token) {
            this.setState({
              submitbuttom: 'submit',
              suubmitvalue: 'Book Car',
              submitbuttom1: 'submit'

            });
          }

        })

        //alert(result.data.data[0].date1);

      }
    })

  }


  imagestore1() {
    this.https.post('/city_list', { token: this.token, type: 1 }).then((result) => {
      let status = result.data.status;
      if (status === 1) {
        this.setState({
          carArray1: result.data.data
        });
      }

    })

  }



  imagestore2() {
    this.https.post('/city_list', { token: this.token, type: 2 }).then((result) => {
      let status = result.data.status;
      if (status === 1) {
        this.setState({
          carArray2: result.data.data
        });
      }

    })

  }



  initiatePayment = async () => {
    this.https.post('/access_payment', { token: this.token }).then((result) => {
      let status = result.data.status;
      if (status === 1) {
        console.log('Payment successful', result.data.data);

        const res = JSON.parse(result.data.data);

        window.location.replace(res.data.instrumentResponse.redirectInfo.url);
        //console.log('successful', res.data.instrumentResponse.redirectInfo.url);
      } else {

        const MySwal = withReactContent(Swal);
        MySwal.fire('Login again Token expired');
      }
    });

  };



  handleSubmit(event) {
    event.preventDefault();
    var name = event.target.name.value;
    var email = event.target.email.value;
    var from_address = event.target.from_address.value;
    var mobile_number = event.target.mobile_number.value;

    if (this.token) { } else {

      const MySwal = withReactContent(Swal);
      MySwal.fire('Please login/signup to book a car.');
      const { navigate } = this.props;
      navigate("../login");
      return true;
      localStorage.setItem('name', name);
      localStorage.setItem('email', email);
      localStorage.setItem('address', from_address);
      localStorage.setItem('mobile_number', mobile_number);
      localStorage.setItem('booking_applay', 1);
    }


    var to_address = event.target.to_address.value;

    if (to_address === '') {


    }


    var fromTime = event.target.fromTime.value;
    var toTime = event.target.toTime.value;
    var person = event.target.person.value;
    var luggage = event.target.luggage.value;
    var comment = event.target.comment.value;
    var rent_id = localStorage.getItem('rent_id')
    const date1 = localStorage.getItem("date");



    this.https.post('/access_payment', {
      //this.https.post('/create_order',{
      token: this.token,
      name: name,
      email: email,
      mobile_number: mobile_number,
      from_address: from_address,
      to_address: to_address,
      fromTime: fromTime,
      toTime: toTime,
      person: person,
      total_in_hours: this.state.totalHours,
      rent: this.state.totalRent,
      rate: this.state.rate,
      newRent: this.state.newRent,
      dis: this.state.dis,
      dis2: this.state.dis2,
      coupon: this.state.coupon,
      insurance: this.state.insurance,
      days: this.state.days,
      hours: this.state.hours,
      ins_amt: this.state.ins_amt,
      gst: this.state.gst1,
      total: this.state.total1,
      luggage: luggage,
      comment: comment,
      car_id: rent_id,
      date1: date1
    }).then((result) => {

      let status = result.data.status;
      if (status === 1) {
        const res = result.data.data; // Get order details from API response
        const transaction_id = res.transaction_id; // Get transaction ID from API response

        const options = {
          key: res.razorpay_key, // Your Razorpay API key
          amount: res.amount, // Amount in paise
          currency: res.currency,
          name: "BookNDrive",
          description: "Car Booking Payment",
          order_id: res.order_id, // Razorpay order ID

          handler: async (response) => {
            try {
              this.setState({ isLoading: true });
              // Send payment details to backend
              this.https.post("/razorpay_callback", {
                token: this.token, // Token received from login
                transaction_id: transaction_id,
                payment_id: response.razorpay_payment_id,
                order_id: response.razorpay_order_id,
                signature: response.razorpay_signature,
              }).then((result) => {
                this.setState({ isLoading: false });
                console.log(result.data);
                if (result.data.status === 1) {
                  const MySwal = withReactContent(Swal);
                  MySwal.fire("Success!", result.data.message, "success");
                  window.location.href = "/booking-list";
                }
              });


            } catch (error) {
              console.log(error);
              const MySwal = withReactContent(Swal);
              MySwal.fire("Error!", "Payment verification failed", "error");
            }
          },
          prefill: {
            name: name, // You can prefill this dynamically
            email: email,
            contact: mobile_number
          },
          theme: {
            color: "#3399cc"
          }
        };

        if (window.Razorpay) {
          const rzp1 = new window.Razorpay(options);
          rzp1.open();
        } else {
          console.error("Razorpay SDK failed to load.");
        }

      } else {

        localStorage.setItem('to_address', this.state.to_address);
        localStorage.setItem('comment', this.state.comment);


        const MySwal = withReactContent(Swal);

        if (result.data.message != 'Please login for access') {
          MySwal.fire(result.data.message);
        }

        if (result.data.message === 'Please login for access') {
          localStorage.setItem('filter', 1)
          const { navigate } = this.props;

          this.https.post('/checkuser', { mobile_number: mobile_number }).then((result) => {
            let status = result.data.status;
            if (status === 1) {
              MySwal.fire(result.data.message);
              navigate("../login");
            } else {
              MySwal.fire('Please Register');
              navigate("../register");
            }

          })
        }


      }


    })
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = () => {
    this.setState({ show: true });
  }





  // handlePayment(id) {
  //   const merchantId = 'BOOKNONLINE';
  //   const apiKey = 'e3f84bd4-f2e9-4ba0-bae9-07aec00e3010';
  //   const redirectUrl = 'http://localhost:3000/car-booking';
  //   const amount = 100; // Replace with the amount to be paid

  //   axios.post(
  //     'https://api.phonepe.com/v3/debit/transaction',
  //     {
  //       merchantId,
  //       transactionAmount: amount, // Additional parameters if required by the API
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${apiKey}`,
  //       },
  //     }
  //   ).then((response) => {
  //     alert('ok');
  //    // window.location.href = response.data.url;
  //    console.log(response);
  //   });



  // }     


  render() {

    const { text, children } = this.props;
    const { showTooltip } = this.state;
    const { coupon_dis } = this.state;
    const { readonly } = this.state;

    //if (this.userData) {

    let msg = '';
    if (this.state.messages) {
      msg = <Alert variant="success"  >
        {this.state.messages}
      </Alert>
    }

    const listItems = this.state.carArray.map((val, key) => {

      let booking_status = val.booking_status;



      return (

        <div className="car-booking-right ">

          <Row>
            <Col>
              <Row className="align-items-center">

                <div className="col-lg-7">
                  <div className="car-booking-image">
                    <img src={config.PUBLIC_URL + val.image} className="border-0" alt="car" />

                  </div>

                </div>
                <div className="col-lg-5">

                  <Row>
                    <div className="col-lg-12">
                      <FaCar className="me-2" />  Model : {val.model_year}
                    </div>

                    <div className="col-lg-12">
                      <img src={OilTypelIcon} className="me-2" width={18} />  Car Type : {val.transmission_type}
                    </div>




                    <div className="col-lg-12">
                      <img src={RoadIcon} className="me-2" width={18} />  Average : {val.avrage}{" "}kmpl
                    </div>

                    <div className="col-lg-12">
                      <FaBarcode className="me-2" /> Car No : {val.car_number}
                    </div>
                  </Row>

                </div>
                <div className="col-lg-12 mt-2">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="car-name"><h5>{val.car_name}&nbsp;{val.model_name}&nbsp;{val.variant_name}</h5></div>
                    </div>
                    <div className="col-lg-4">
                      <div className="price-rent">
                        <h4> <FaRupeeSign />{val.price}<span>/ HOUR</span></h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div class="description-container">
                    <p>{val.description}</p>
                  </div>
                </div>
              </Row>

            </Col>
          </Row>



        </div>

      )
    });

    const divStyle = {
      display: 'none'
    };


    const listItems1 = this.state.carArray1.map((val, key) => {

      const from = localStorage.getItem('from');

      if (from === val.city) {
        return (

          <option value={val.city} selected>{val.city}</option>

        )
      } else {
        return (

          <option value={val.city} >{val.city}</option>

        )

      }


    });

    const listItems2 = this.state.carArray2.map((val, key) => {

      const to_address = localStorage.getItem('to_address');

      if (to_address === val.city) {
        return (

          <option value={val.city} selected>{val.city}</option>

        )
      } else {
        return (

          <option value={val.city} >{val.city}</option>

        )
      }
    });



    return (
      <Fragment>
        {this.state.isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 bg-white d-flex justify-content-center align-items-center" style={{ zIndex: 9999 }}>
            <div className="text-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="fw-bold">Please don't refresh the page...</p>
            </div>
          </div>
        )}

        <Header />

        <section className="py-4 bg-light">
          <div className="container">
            <Form onSubmit={this.handleSubmit} id="account_form">
              <div className="row g-4">
                {/* Left Column - Form Content */}
                <div className="col-lg-8">
                  {/* Breadcrumb */}
                  <nav aria-label="breadcrumb" className="mb-4">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard"><FaHome className="me-1" /> Home</Link>
                      </li>
                      <li className="breadcrumb-item active">Car Booking</li>
                    </ol>
                  </nav>

                  {/* Car Selection */}
                  <div className="card shadow-sm mb-4">
                    <div className="card-body">
                      <h4 className="card-title mb-3">Selected Vehicle</h4>
                      {listItems}
                    </div>
                  </div>

                  {/* Form Sections */}
                  <div className="card shadow-sm mb-4">
                    <div className="card-body">
                      {msg && (
                        <div className="alert alert-info" role="alert">
                          {msg}
                        </div>
                      )}

                      {/* Personal Information */}
                      <div className="booking-section mb-4">
                        <h4 className="card-title border-bottom pb-2 mb-4">Personal Information</h4>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Full Name</label>
                            <input
                              type="text"
                              value={this.state.name}
                              name="name"
                              onChange={this.handleChange}
                              placeholder="Your Full Name"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Email ID</label>
                            <input
                              className="form-control"
                              type="email"
                              value={this.state.email}
                              name="email"
                              onChange={this.handleChange}
                              placeholder="Your Email Address"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Phone Number</label>
                            <input
                              className="form-control"
                              type="tel"
                              name="mobile_number"
                              id="mobile_number"
                              value={this.state.mobile_number}
                              onChange={this.handleChange}
                              placeholder="Your Phone Number"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Booking Details */}
                      <div className="booking-section">
                        <h4 className="card-title border-bottom pb-2 mb-4">Booking Details</h4>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Pick Location</label>
                            <select
                              name="from_address"
                              className="form-select"
                              value={this.state.from_address}
                              onChange={this.handleChange}
                            >
                              <option value="">Select Pick Location</option>
                              {listItems1}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Drop Location</label>
                            <select
                              name="to_address"
                              className="form-select"
                              value={this.state.to_address}
                              onChange={this.handleChange}
                            >
                              <option value="">Select Drop Location</option>
                              {listItems2}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">From Date/Time</label>
                            <input
                              type="text"
                              format="DD/MM/YYYY HH:mm:ss"
                              className="form-control"
                              placeholder="From Date/Time"
                              value={this.state.fromTime}
                              name="fromTime"
                              onChange={this.handleChange}
                              readOnly={true}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">To Date/Time</label>
                            <input
                              type="text"
                              format="DD/MM/YYYY HH:mm:ss"
                              className="form-control"
                              placeholder="To Date/Time"
                              value={this.state.toTime}
                              name="toTime"
                              onChange={this.handleChange}
                              readOnly={true}
                            />
                          </div>
                          <div className="col-md-6" style={divStyle}>
                            <label className="form-label fw-bold">Number of Passengers</label>
                            <select
                              className="form-select"
                              value={this.state.person}
                              onChange={this.handleChange}
                              name="person"
                            >
                              <option value="1 person">1 person</option>
                              <option value="2 person">2 Person</option>
                              <option value="3 person">3 Person</option>
                              <option value="4 person">4 Person</option>
                              <option value="5-10 person">5-10 Person</option>
                            </select>
                          </div>
                          <div className="col-md-6" style={divStyle}>
                            <label className="form-label fw-bold">Luggage</label>
                            <select
                              value={this.state.luggage}
                              onChange={this.handleChange}
                              name="luggage"
                              className="form-select"
                            >
                              <option value="1 Luggage">1 Luggage</option>
                              <option value="2 Luggage">2 Luggage</option>
                              <option value="3 Luggage">3 Luggage</option>
                              <option value="4(+) Luggage">4(+) Luggage</option>
                            </select>
                          </div>
                          <div className="col-12">
                            <label className="form-label fw-bold">Visiting Location</label>
                            <textarea
                              onChange={this.handleChange}
                              name="comment"
                              className="form-control"
                              value={this.state.comment}
                              placeholder="Write down the name of the location you will be visiting"
                              rows="3"
                            >
                              {localStorage.getItem('comment') === 'undefined' ? '' : localStorage.getItem('comment')}
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Payment Summary */}
                <div className="col-lg-4">
                  <div className="card shadow-sm sticky-top" style={{ top: "20px" }}>
                    <div className="card-header bg-dark text-white">
                      <h4 className="card-title mb-0">Payment Details</h4>
                    </div>
                    <div className="card-body">
                      {/* Coupon Section */}
                      <div className="mb-4">
                        <div className="input-group mb-2">
                          <input
                            value={this.state.coupon}
                            onChange={this.handleChanges}
                            readOnly={this.state.readOnly}
                            name="coupon"
                            placeholder="Enter Coupon Code"
                            type="text"
                            className="form-control"
                          />
                          <button
                            className="btn btn-primary"
                            onClick={this.handleCoupon}
                            type="button"
                          >
                            Apply
                          </button>
                        </div>
                        {coupon_dis && (
                          <div className="d-flex justify-content-between align-items-center px-2 py-1 bg-light rounded">
                            <span className="text-success fw-bold">Coupon Discount {this.state.dis2}%</span>
                            <button
                              onClick={this.handleCoupons}
                              className="btn btn-sm btn-danger"
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Price Summary */}
                      <div className="border-top pt-3">
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item d-flex justify-content-between px-0">
                            <span>Duration:</span>
                            <span className="fw-bold">{this.state.days} days {this.state.hours} Hours</span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between px-0">
                            <span>Total Rent:</span>
                            <span className="fw-bold">₹{this.state.totalRent}</span>
                          </li>
                          {coupon_dis && (
                            <>
                              <li className="list-group-item d-flex justify-content-between px-0 text-success">
                                <span>Discount:</span>
                                <span className="fw-bold">-₹{this.state.dis}</span>
                              </li>
                              <li className="list-group-item d-flex justify-content-between px-0">
                                <span>New Rent:</span>
                                <span className="fw-bold">₹{this.state.newRent}</span>
                              </li>
                            </>
                          )}
                          <li className="list-group-item d-flex justify-content-between px-0">
                            <span>Convenience Fee:</span>
                            <span className="fw-bold">₹{this.state.gst}</span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between px-0 border-top border-bottom">
                            <span className="fw-bold">Total Amount:</span>
                            <span className="fw-bold fs-5">₹{this.state.total}</span>
                          </li>
                        </ul>
                      </div>

                      {/* Submit Button */}
                      <div className="mt-4 d-grid">
                        <input
                          readOnly={this.state.attrs}
                          type={this.state.submitbuttom}
                          className="btn btn-lg btn-success"
                          value={this.state.suubmitvalue}
                          onClick={this.handleChangep}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </section>

        <Footer />
      </Fragment>
    );

    //} else {
    //  window.location.replace('./');
    // const { navigate } = this.props;
    // navigate("../login");
    //}

  }
}

export default NavigateWrapper;